export default __webpack_public_path__ + "static/media/tanker-truck.f5493ebd.svg";